<mat-card appearance="outlined" class="library-tree-card">
  <mat-card-actions class="tree-toolbar">
    @if (libraryType() === LibraryT.PUBLIC) {
      <button
        class="app-normal-button"
        matButton="elevated"
        color="primary"
        (click)="onAddDocument(LibraryT.PUBLIC)"
      >
        <mat-icon>post_add</mat-icon> <span i18n>Add Document</span>
      </button>
    } @if (libraryType() === LibraryT.PERSONAL) {
    <button
      class="app-normal-button"
      matButton="elevated"
      color="primary"
      (click)="onAddDocument(LibraryT.PERSONAL)"
    >
      <mat-icon>contact_page</mat-icon> <span i18n>Add Personal Document</span>
    </button>
  } @if (libraryType() === LibraryT.PUBLIC) {
    <button
      class="app-normal-button"
      matButton="elevated"
      color="primary"
      (click)="onAddDirectory(LibraryT.PUBLIC)"
    >
      <mat-icon>create_new_folder</mat-icon> <span i18n>Add Directory</span>
    </button>
  } @if (libraryType() === LibraryT.PERSONAL) {
    <button
      class="app-normal-button"
      matButton="elevated"
      color="primary"
      (click)="onAddDirectory(LibraryT.PERSONAL)"
    >
      <mat-icon>folder_shared</mat-icon> <span i18n>Add Personal Folder</span>
    </button>
  }
  </mat-card-actions>

  <mat-card-content>
    <div
      class="tree-container"
      cdkDropList
      cdkDropListDisabled="{{ libraryType() === LibraryT.PERSONAL }}"
      (cdkDropListDropped)="drop($event)"
    >
      @for (node of flatTreeData; track node.uuid) {
        @if (node.isVisible) {
          <div
            class="tree-node"
            [class.tree-node-expanded]="hasChildren(node) && isExpanded(node)"
            [style.padding-left.px]="node.level * 20"
            cdkDrag
            [cdkDragData]="node"
            (mouseenter)="dragHover(node)"
            (mouseleave)="dragHoverEnd()"
            (cdkDragStarted)="dragStart()"
            (cdkDragReleased)="dragEnd()"
          >
            <!-- Toggle button for expandable nodes -->
            @if (hasChildren(node)) {
              <button
                matIconButton
                class="tree-toggle-button"
                (click)="toggleNode(node)"
                [attr.aria-label]="'toggle ' + node.name"
              >
                <mat-icon class="mat-icon-rtl-mirror">
                  {{ isExpanded(node) ? "expand_more" : "chevron_right" }}
                </mat-icon>
              </button>
            } @else {
              <span class="tree-toggle-spacer"></span>
            }

            <!-- Node content -->
            <div class="tree-node-content flex-row start-center">
              <!-- File/Directory icon -->
              @if (node.type === FileT.DIRECTORY) {
                <span class="tree-icon">
                  <mat-icon style="color: grey">folder</mat-icon>
                </span>
              } @else {
                <span class="tree-icon">
                  <mat-icon style="color: grey">description</mat-icon>
                </span>
              }

              <!-- Node name -->
              <span class="tree-node-name" [matTooltip]="node.name">
                {{ node.name }}
              </span>

              <!-- Action buttons -->
              <div class="tree-node-actions">
                @if (node.type === FileT.FILE) {
                  @if (node.canView) {
                    <button
                      matIconButton
                      class="tree-action-button"
                      (click)="viewDocument(node.uuid)"
                      matTooltip="View Document" aria-label="View document"
                    >
                      <mat-icon>visibility</mat-icon>
                    </button>
                  }
                  <button
                    matIconButton
                    class="tree-action-button"
                    (click)="updateDocument(node.uuid, libraryType())"
                    matTooltip="Edit Document" aria-label="Edit document"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    matIconButton
                    class="tree-action-button"
                    (click)="deleteDocument(node.uuid)"
                    matTooltip="Delete Document" aria-label="Delete document"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                } @else if (node.type === FileT.DIRECTORY) {
                  <button
                    matIconButton
                    class="tree-action-button"
                    (click)="updateDirectory(node.uuid)"
                    matTooltip="Edit Directory" aria-label="Edit directory"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  @if (!hasChildren(node)) {
                    <button
                      matIconButton
                      class="tree-action-button"
                      (click)="deleteDirectory(node.uuid, libraryType())"
                      matTooltip="Delete Directory" aria-label="Delete directory"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  }
                }
              </div>
            </div>
          </div>
        }
      }

      @if (flatTreeData.length === 0) {
        <div class="tree-empty-state">
          <mat-icon class="tree-empty-icon">folder_open</mat-icon>
          <p>No documents or directories found</p>
        </div>
      }
    </div>
  </mat-card-content>
</mat-card>
